import React from "react";

// Versão vigente dos termos. Ao alterar o texto de forma relevante,
// atualizar também TERMOS_VERSAO_ATUAL no back (termos-uso-service.ts)
// pra disparar um novo ciclo de aceite.
export const TERMOS_VERSAO = "2026-07-09";

/**
 * Só o texto dos termos + política, com estilos escopados em
 * .termos-conteudo — embeddável em modais (aceite, cadastro) além da
 * página pública /termos.
 */
export const TermosTexto = () => {
	return (
		<div className="termos-conteudo">
			<style>{`
        .termos-conteudo {
            line-height: 1.6;
            color: #333;
            text-align: left;
        }
        .termos-conteudo h1 {
            color: #f97316;
            border-bottom: 2px solid #f97316;
            padding-bottom: 10px;
            margin-top: 16px;
            font-size: 1.6em;
        }
        .termos-conteudo h2 {
            color: #1f2937;
            margin-top: 30px;
            border-bottom: 1px solid #e5e7eb;
            padding-bottom: 5px;
            font-size: 1.25em;
        }
        .termos-conteudo h3 {
            color: #374151;
            margin-top: 25px;
            font-size: 1.05em;
        }
        .termos-conteudo a {
            color: #f97316;
            text-decoration: none;
        }
        .termos-conteudo a:hover {
            text-decoration: underline;
        }
        .termos-conteudo ul, .termos-conteudo ol {
            padding-left: 20px;
        }
        .termos-conteudo hr {
            border: 0;
            height: 1px;
            background-color: #e5e7eb;
            margin: 40px 0;
        }
        .termos-conteudo .updated {
            color: #6b7280;
            font-style: italic;
            margin-bottom: 20px;
        }
      `}</style>

			<div className="updated">
				Última atualização: 9 de julho de 2026 — versão {TERMOS_VERSAO}
			</div>

			<div id="terms">
				<h1>Termos de uso — treino.io</h1>

				<h2>1. Aceitação dos termos</h2>
				<p>
					Estes termos de uso regulam o acesso e o uso da plataforma
					treino.io, que compreende a plataforma web utilizada por
					profissionais (treinadores e nutricionistas) e o aplicativo
					móvel utilizado por alunos. Ao aceitar estes termos — no
					cadastro, no primeiro acesso ou quando uma nova versão for
					publicada — você concorda em cumpri-los integralmente. Se
					você não concordar com algum aspecto destes termos, não
					utilize a plataforma.
				</p>
				<p>
					O aceite é registrado eletronicamente, com identificação do
					usuário, data e versão dos termos aceita.
				</p>

				<h2>2. Descrição do serviço</h2>
				<p>
					O treino.io é uma plataforma que conecta profissionais de
					educação física e nutricionistas a seus alunos/clientes.
					Nossos serviços incluem, mas não se limitam a:
				</p>
				<ul>
					<li>Prescrição e gerenciamento de fichas de treino e dieta</li>
					<li>Execução de treinos e registro de cargas, repetições e cardio</li>
					<li>Acesso a vídeos de execução de exercícios</li>
					<li>Questionários de avaliação e feedback, com envio de fotos</li>
					<li>Comparativos de fotos de progresso e avaliações físicas</li>
					<li>Chat e comunidades entre profissional e alunos</li>
					<li>Recursos de gamificação (pontos, rankings e competições)</li>
					<li>Materiais extras disponibilizados pelo profissional</li>
					<li>
						Módulo financeiro para cobrança dos alunos pelo
						profissional, quando habilitado
					</li>
				</ul>
				<p>
					A plataforma está em evolução constante: funcionalidades
					podem ser adicionadas, alteradas, disponibilizadas
					gradualmente (inclusive em caráter experimental, para
					parte dos usuários) ou descontinuadas a qualquer momento;
					mudanças relevantes serão comunicadas na própria
					plataforma. Não garantimos disponibilidade ininterrupta: o
					serviço pode ficar temporariamente indisponível por
					manutenções programadas ou emergenciais.
				</p>

				<h2>3. Cadastro e conta</h2>

				<h3>3.1. Elegibilidade</h3>
				<p>
					Para usar o treino.io, você deve ter pelo menos 13 anos de
					idade. Se você for menor de 18 anos, deve ter permissão de
					um pai ou responsável legal.
				</p>

				<h3>3.2. Informações de cadastro</h3>
				<p>
					Ao se cadastrar, você concorda em fornecer informações
					precisas, atualizadas e completas. Você é responsável por
					manter a confidencialidade de sua senha e por todas as
					atividades que ocorrem em sua conta, inclusive as
					realizadas por contas de funcionários/colaboradores
					vinculadas à sua conta principal.
				</p>

				<h3>3.3. Verificação de credenciais profissionais</h3>
				<p>
					Profissionais de educação física e nutricionistas podem ser
					solicitados a fornecer credenciais válidas para verificar
					sua qualificação profissional.
				</p>

				<h3>3.4. Comunicações</h3>
				<p>
					Ao criar sua conta, você concorda em receber comunicações
					operacionais relacionadas ao serviço — avisos de cobrança,
					notificações de treino e feedback, atualizações destes
					termos — por e-mail, notificações push e aplicativos de
					mensagem, como o WhatsApp. Comunicações promocionais são
					opcionais e podem ser desativadas a qualquer momento.
				</p>

				<h2>4. Relação entre profissional e aluno</h2>

				<h3>4.1. Papel da plataforma</h3>
				<p>
					O treino.io é uma ferramenta tecnológica. O serviço de
					consultoria (prescrição de treinos, dietas e
					acompanhamento) é prestado pelo profissional, que é o único
					responsável pelo conteúdo das prescrições, pelas
					orientações dadas aos seus alunos e pelo cumprimento das
					normas éticas e legais de sua profissão. O treino.io não
					revisa, não valida e não endossa as prescrições e
					orientações feitas através da plataforma, não presta
					aconselhamento médico, nutricional ou de treinamento e não
					se responsabiliza pela relação contratual entre
					profissional e aluno.
				</p>

				<h3>4.2. Dados nutricionais e de referência</h3>
				<p>
					As informações nutricionais disponíveis na plataforma —
					calorias, macronutrientes, medidas caseiras e demais dados
					de composição de alimentos — têm origem em tabelas
					públicas de referência e/ou em cadastros feitos pelos
					próprios profissionais, e são fornecidas apenas como apoio
					à prescrição, podendo conter imprecisões ou divergências
					entre fontes. É responsabilidade exclusiva do profissional
					conferir, ajustar e validar os dados nutricionais
					utilizados em suas prescrições; o treino.io não garante a
					exatidão dessas informações nem se responsabiliza por
					prescrições baseadas nelas.
				</p>

				<h3>4.3. Vídeos e materiais de apoio</h3>
				<p>
					Vídeos de execução de exercícios e demais materiais
					disponíveis na plataforma são conteúdo de apoio. A escolha
					dos exercícios, a adequação deles a cada aluno e a
					orientação sobre a execução correta são responsabilidade
					do profissional.
				</p>

				<h3>4.4. Acesso do aluno</h3>
				<p>
					O acesso do aluno ao aplicativo depende de vínculo ativo
					com um profissional e da regularidade da assinatura desse
					profissional na plataforma. O bloqueio, o cancelamento ou
					o encerramento da conta do profissional pode suspender ou
					encerrar o acesso dos seus alunos, sem que isso gere
					qualquer responsabilidade do treino.io perante o aluno.
					Quando o módulo financeiro estiver habilitado, o
					profissional também pode condicionar o acesso do aluno ao
					pagamento da consultoria.
				</p>

				<h2>5. Assinatura da plataforma (profissional)</h2>
				<ul>
					<li>
						Os planos de assinatura, seus valores e condições são os
						divulgados na própria plataforma, na página de
						assinatura, e podem ser alterados mediante aviso prévio
					</li>
					<li>
						A cobrança é recorrente, conforme o ciclo do plano
						contratado, podendo incluir valor variável por aluno
						ativo; a parcela variável integra a assinatura para
						todos os efeitos destes termos, inclusive os de
						inadimplência
					</li>
					<li>
						Qualquer cobrança da assinatura (fixa ou variável)
						vencida e não paga há 7 (sete) dias ou mais poderá
						resultar no bloqueio do acesso à plataforma até a
						regularização
					</li>
					<li>
						Qualquer cobrança da assinatura em aberto há mais de 15
						(quinze) dias poderá resultar no cancelamento da
						assinatura e no encerramento do acesso, sem prejuízo da
						cobrança dos valores devidos até o cancelamento
					</li>
					<li>
						O bloqueio ou o cancelamento por inadimplência do
						profissional também suspende o acesso dos seus alunos,
						conforme a seção 4.4
					</li>
					<li>
						Você pode cancelar sua assinatura a qualquer momento;
						não há reembolso para períodos parciais de uso, salvo
						disposição legal em contrário
					</li>
					<li>
						Descontos, cupons, cortesias, sorteios e demais
						benefícios promocionais têm condições próprias, podem
						ser alterados ou encerrados a qualquer momento e não
						constituem direito adquirido
					</li>
				</ul>

				<h2>6. Cobrança de alunos pelo profissional</h2>
				<p>
					Quando o módulo financeiro estiver habilitado, o
					profissional pode cobrar seus alunos dentro da plataforma.
					Nesse caso:
				</p>
				<ul>
					<li>
						Os pagamentos são processados por parceiro de meios de
						pagamento; o treino.io atua como intermediária
						tecnológica
					</li>
					<li>
						Os valores, planos e condições da consultoria são
						definidos exclusivamente pelo profissional
					</li>
					<li>
						As taxas de processamento aplicáveis são exibidas na
						plataforma no momento da configuração da cobrança
					</li>
					<li>
						Disputas sobre o serviço de consultoria (qualidade,
						cancelamento, reembolso) devem ser resolvidas entre
						aluno e profissional
					</li>
					<li>
						O profissional é o único responsável pelas obrigações
						fiscais e tributárias sobre os valores recebidos de
						seus alunos, incluindo a emissão de nota fiscal quando
						exigida
					</li>
					<li>
						Estornos, contestações (chargebacks) e disputas de
						pagamento seguem as regras do parceiro de meios de
						pagamento e podem resultar na retenção ou na reversão
						de valores; o uso fraudulento do módulo financeiro pode
						resultar em bloqueio ou encerramento da conta
					</li>
				</ul>

				<h2>
					7. Uso de dados de crescimento para marketing
					(profissional)
				</h2>
				<p>
					Ao aceitar estes termos, o profissional autoriza o
					treino.io a utilizar os seus dados de crescimento na
					plataforma em ações de marketing e divulgação do serviço —
					por exemplo, indicadores de crescimento da consultoria,
					como número de alunos atendidos, evolução da consultoria e
					estatísticas de uso da plataforma.
				</p>
				<p>
					Sempre que possível, esses dados serão utilizados de forma
					agregada e/ou anonimizada. A utilização de dados que
					identifiquem o profissional diretamente (como nome completo
					ou imagem) em materiais de divulgação dependerá de
					autorização específica adicional.
				</p>
				<p>
					<strong>
						Esta autorização não se aplica aos dados dos alunos:
					</strong>{" "}
					os dados de evolução física e de uso do aluno são tratados
					exclusivamente para a prestação do serviço, conforme a
					política de privacidade, e não são utilizados em ações de
					marketing.
				</p>
				<p>
					O profissional pode revogar esta autorização a qualquer
					momento pelo e-mail contato@treino.io, sem prejuízo do uso
					da plataforma.
				</p>

				<h2>8. Conteúdo do usuário</h2>
				<p>
					Você mantém a propriedade de todo o conteúdo que cria,
					envia, publica ou indica por link através do treino.io —
					incluindo fichas, dietas, questionários, mensagens, posts,
					fotos, vídeos de execução de exercícios e materiais
					extras. No entanto, você concede ao treino.io uma licença
					mundial, não exclusiva e isenta de royalties para usar,
					reproduzir, armazenar e distribuir esse conteúdo na medida
					necessária à prestação do serviço.
				</p>
				<p>
					Você é o único responsável pelo conteúdo que cria, envia,
					publica ou indica, incluindo sua legalidade,
					confiabilidade e adequação, e declara possuir os direitos
					necessários sobre ele. O treino.io pode remover conteúdo
					que viole direitos de terceiros ou estes termos.
				</p>

				<h2>9. Uso aceitável</h2>
				<p>
					Você concorda em usar o treino.io apenas para fins legais e
					de acordo com estes termos. Você não pode:
				</p>
				<ul>
					<li>
						Usar o serviço para qualquer finalidade ilegal ou não
						autorizada
					</li>
					<li>Violar qualquer lei ou regulamento aplicável</li>
					<li>Infringir os direitos de terceiros</li>
					<li>Interferir ou prejudicar a operação do serviço</li>
					<li>
						Tentar acessar partes da plataforma para as quais você
						não tem permissão
					</li>
					<li>Distribuir vírus ou outros códigos maliciosos</li>
					<li>
						Publicar, em chats e comunidades, conteúdo ofensivo,
						discriminatório, de assédio, violento, sexualmente
						explícito ou spam
					</li>
					<li>
						Compartilhar sua conta ou credenciais para burlar os
						limites e as cobranças da plataforma
					</li>
				</ul>
				<p>
					O treino.io pode remover conteúdo e suspender ou encerrar
					contas que violem estas regras.
				</p>

				<h2>10. Responsabilidades do profissional</h2>
				<p>
					Profissionais de educação física e nutricionistas que
					utilizam o treino.io concordam em:
				</p>
				<ul>
					<li>
						Fornecer orientações profissionais dentro de seu escopo
						de prática
					</li>
					<li>Seguir os padrões éticos e legais de sua profissão</li>
					<li>
						Não fazer alegações médicas ou de saúde sem embasamento
					</li>
					<li>
						Respeitar a confidencialidade e a privacidade dos dados
						de seus alunos, utilizando-os apenas para a prestação da
						consultoria
					</li>
					<li>
						Obter dos seus alunos as informações de saúde
						necessárias à prescrição e considerar as restrições
						informadas
					</li>
					<li>
						Conferir e validar os dados nutricionais e demais
						valores de referência utilizados em suas prescrições,
						conforme a seção 4.2
					</li>
					<li>
						Possuir os direitos necessários sobre os vídeos e
						materiais que envia ou indica na plataforma
					</li>
				</ul>

				<h2>11. Propriedade intelectual</h2>

				<h3>11.1. Propriedade do treino.io</h3>
				<p>
					A plataforma treino.io, incluindo seu design, código,
					conteúdo, recursos e funcionalidades, é de propriedade
					exclusiva do treino.io e está protegida por leis de
					direitos autorais, marcas registradas e outras leis de
					propriedade intelectual.
				</p>

				<h3>11.2. Licença de uso</h3>
				<p>
					Concedemos a você uma licença limitada, não exclusiva, não
					transferível e revogável para usar o treino.io para seu uso
					pessoal ou profissional, sujeita a estes termos.
				</p>

				<h3>11.3. Restrições</h3>
				<p>Você não pode:</p>
				<ul>
					<li>
						Copiar, modificar ou criar trabalhos derivados da
						plataforma
					</li>
					<li>Fazer engenharia reversa do software</li>
					<li>
						Remover avisos de direitos autorais ou outros avisos de
						propriedade
					</li>
					<li>
						Usar a plataforma para desenvolver produtos ou serviços
						concorrentes
					</li>
				</ul>

				<h2>12. Término</h2>

				<h3>12.1. Término por você</h3>
				<p>
					Você pode encerrar sua conta a qualquer momento cancelando
					sua assinatura e excluindo sua conta.
				</p>

				<h3>12.2. Término por nós</h3>
				<p>
					Podemos suspender ou encerrar seu acesso ao treino.io em
					caso de violação destes termos, inadimplência ou uso
					indevido da plataforma.
				</p>

				<h3>12.3. Efeitos do término</h3>
				<p>
					Após o término, seu direito de usar a plataforma cessará
					imediatamente. Podemos, mas não somos obrigados a, excluir
					qualquer conteúdo ou informação que você tenha enviado
					através do serviço, observada a política de retenção
					descrita na política de privacidade.
				</p>

				<h2>13. Isenções e limitações de responsabilidade</h2>

				<h3>13.1. Isenção de garantias</h3>
				<p>
					O treino.io é fornecido "como está" e "conforme
					disponível", sem garantias de qualquer tipo, expressas ou
					implícitas.
				</p>

				<h3>
					13.2. Conselho profissional e riscos da atividade física
				</h3>
				<p>
					O treino.io não fornece aconselhamento médico. A plataforma
					facilita a comunicação entre profissionais e seus clientes,
					mas não substitui a consulta médica profissional. A prática
					de exercícios físicos e a adoção de planos alimentares
					envolvem riscos inerentes à saúde. Consulte um médico antes
					de iniciar qualquer programa de exercícios ou dieta; em
					caso de dor, mal-estar ou qualquer sintoma anormal durante
					um treino, interrompa a atividade imediatamente, informe
					seu profissional e procure atendimento médico. O treino.io
					não monitora a execução dos treinos em tempo real.
				</p>

				<h3>13.3. Limitação de responsabilidade</h3>
				<p>
					Em nenhuma circunstância o treino.io será responsável por
					danos indiretos, incidentais, especiais, consequenciais ou
					punitivos resultantes do uso ou da incapacidade de usar o
					serviço — incluindo lesões ou outros danos à saúde
					decorrentes da execução de treinos ou dietas prescritos
					por profissionais, imprecisões em dados nutricionais de
					referência e prejuízos decorrentes de disputas entre
					profissional e aluno. Nossa responsabilidade total para
					com você por qualquer dano não excederá o valor pago por
					você ao treino.io nos últimos três meses antes da
					reivindicação.
				</p>

				<h2>14. Indenização</h2>
				<p>
					Você concorda em indenizar e isentar o treino.io, seus
					diretores, funcionários e agentes de quaisquer
					reivindicações, responsabilidades, danos, perdas e
					despesas, incluindo honorários advocatícios razoáveis,
					decorrentes de ou de alguma forma relacionados ao seu
					acesso ou uso do serviço, seu conteúdo ou sua violação
					destes termos.
				</p>

				<h2>15. Modificações nos termos</h2>
				<p>
					Podemos modificar estes termos a qualquer momento. Quando
					publicarmos uma nova versão, você será notificado na
					plataforma ou no aplicativo e poderá ser solicitado a
					aceitar a versão atualizada para continuar utilizando o
					serviço.
				</p>

				<h2>16. Disposições gerais</h2>

				<h3>16.1. Lei aplicável</h3>
				<p>
					Estes termos serão regidos e interpretados de acordo com as
					leis do Brasil.
				</p>

				<h3>16.2. Resolução de disputas</h3>
				<p>
					Quaisquer disputas decorrentes ou relacionadas a estes
					termos serão preferencialmente resolvidas de forma
					amigável. Não sendo possível, fica eleito o foro do
					domicílio do usuário, quando este for consumidor, para
					dirimir as controvérsias.
				</p>

				<h3>16.3. Independência das cláusulas</h3>
				<p>
					Se qualquer disposição destes termos for considerada
					inexequível ou inválida, essa disposição será limitada ou
					eliminada na medida mínima necessária, e as demais
					disposições permanecerão em pleno vigor e efeito.
				</p>

				<h3>16.4. Integralidade do acordo</h3>
				<p>
					Estes termos constituem o acordo completo entre você e o
					treino.io em relação ao uso da plataforma e substituem
					quaisquer acordos anteriores.
				</p>

				<h3>16.5. Renúncia</h3>
				<p>
					A falha do treino.io em exercer ou fazer cumprir qualquer
					direito ou disposição destes termos não constituirá uma
					renúncia a tal direito ou disposição.
				</p>

				<h2>17. Contato</h2>
				<p>
					Se você tiver dúvidas sobre estes termos de uso, entre em
					contato conosco:
				</p>
				<p>
					<strong>E-mail:</strong> contato@treino.io
				</p>
			</div>

			<hr />

			<div id="privacy">
				<h1>Política de privacidade — treino.io</h1>

				<h2>1. Introdução</h2>
				<p>
					Esta política de privacidade descreve como coletamos,
					usamos, armazenamos e protegemos suas informações pessoais
					quando você utiliza a plataforma web e o aplicativo móvel
					do treino.io. O treino.io está comprometido em proteger sua
					privacidade e seus dados pessoais em conformidade com as
					leis e regulamentos aplicáveis, incluindo a Lei Geral de
					Proteção de Dados (LGPD — Lei nº 13.709/2018).
				</p>
				<p>
					No tratamento dos dados da consultoria — prescrições,
					avaliações, respostas a questionários, fotos de progresso
					e demais dados do aluno coletados no âmbito do
					acompanhamento —, o profissional atua como controlador e o
					treino.io como operador, tratando esses dados conforme as
					instruções do profissional e esta política. Para os dados
					de conta, assinatura, pagamento e uso da plataforma, o
					treino.io atua como controlador.
				</p>

				<h2>2. Informações que coletamos</h2>

				<h3>2.1. Informações que você nos fornece:</h3>
				<ul>
					<li>
						<strong>Informações de cadastro:</strong> nome, endereço
						de e-mail, número de telefone, CPF (quando aplicável),
						senha
					</li>
					<li>
						<strong>Informações de perfil:</strong> foto, data de
						nascimento, gênero, altura, peso, objetivos de
						condicionamento físico
					</li>
					<li>
						<strong>Dados de saúde e medidas corporais:</strong>{" "}
						respostas a questionários e anamneses, medidas,
						avaliações físicas, fotos de progresso — tratados para
						viabilizar a consultoria prestada pelo seu profissional
					</li>
					<li>
						<strong>Informações profissionais:</strong> (para
						profissionais de educação física e nutricionistas)
						credenciais, especialidades, informações de contato
						profissional
					</li>
					<li>
						<strong>Conteúdo gerado pelo usuário:</strong> fichas de
						treino, planos nutricionais, fotos de progresso,
						mensagens, posts em comunidades, comentários e
						feedbacks
					</li>
					<li>
						<strong>Dados de pagamento:</strong> processados pelo
						nosso parceiro de meios de pagamento; não armazenamos
						os dados completos do seu cartão
					</li>
				</ul>

				<h3>2.2. Informações coletadas automaticamente:</h3>
				<ul>
					<li>
						<strong>Dados de uso:</strong> informações sobre como
						você utiliza a plataforma, incluindo registros de
						treinos concluídos, dietas seguidas, tempo de uso
					</li>
					<li>
						<strong>Informações do dispositivo:</strong> modelo do
						dispositivo, sistema operacional, identificadores
						únicos, informações de rede
					</li>
					<li>
						<strong>Cookies e tecnologias similares:</strong>{" "}
						utilizamos cookies e tecnologias semelhantes para
						melhorar sua experiência, entender como você usa a
						plataforma e personalizar nossos serviços
					</li>
				</ul>

				<h2>3. Como utilizamos suas informações</h2>
				<p>Utilizamos suas informações para:</p>
				<ul>
					<li>
						Fornecer, manter e melhorar a plataforma treino.io e
						seus serviços
					</li>
					<li>
						Personalizar sua experiência com base em suas
						preferências e uso
					</li>
					<li>
						Facilitar a comunicação entre profissionais (personal
						trainers/nutricionistas) e seus alunos/clientes
					</li>
					<li>
						Processar as cobranças da assinatura e, quando
						habilitado, as cobranças do profissional aos seus
						alunos
					</li>
					<li>
						Enviar notificações relacionadas ao serviço e
						informações importantes por e-mail, notificações push e
						aplicativos de mensagem, como o WhatsApp
					</li>
					<li>
						Analisar tendências e comportamentos dos usuários para
						melhorar nossos serviços
					</li>
					<li>
						Realizar ações de marketing com dados de crescimento do
						profissional, conforme a seção 5 desta política
					</li>
					<li>
						Detectar, investigar e prevenir atividades fraudulentas
						e violações dos nossos termos de uso
					</li>
					<li>Cumprir obrigações legais</li>
				</ul>

				<h2>4. Compartilhamento de informações</h2>
				<p>
					Podemos compartilhar suas informações nas seguintes
					circunstâncias:
				</p>
				<ul>
					<li>
						<strong>Entre profissionais e clientes:</strong> quando
						você se conecta com um profissional ou cliente através
						da plataforma, informações relevantes são compartilhadas
						para viabilizar o relacionamento profissional
					</li>
					<li>
						<strong>Operadores e parceiros técnicos:</strong>{" "}
						provedores de hospedagem, processamento de pagamentos,
						envio de notificações, e-mail e mensagens — apenas na
						medida necessária à prestação do serviço
					</li>
					<li>
						<strong>Requisitos legais:</strong> podemos divulgar
						informações quando exigido por lei ou em resposta a
						processos legais
					</li>
					<li>
						<strong>Transferência de negócio:</strong> em caso de
						fusão, aquisição ou venda de ativos, suas informações
						podem ser transferidas para a nova entidade
					</li>
					<li>
						<strong>Com seu consentimento:</strong> podemos
						compartilhar informações com terceiros quando você
						autorizar expressamente
					</li>
				</ul>
				<p>
					Não vendemos nem alugamos suas informações pessoais a
					terceiros.
				</p>

				<h2>
					5. Uso de dados de crescimento para marketing
					(profissional)
				</h2>
				<p>
					Ao aceitar os termos de uso, o profissional autoriza o
					treino.io a utilizar os seus dados de crescimento na
					plataforma (indicadores de crescimento da consultoria, como
					número de alunos atendidos, evolução da consultoria e
					estatísticas de uso) em ações de marketing e divulgação do
					serviço, preferencialmente de forma agregada e/ou
					anonimizada.
				</p>
				<p>
					<strong>Os dados dos alunos não são utilizados para
					marketing:</strong>{" "}
					dados de evolução física, fotos de progresso e demais
					informações do aluno são tratados exclusivamente para a
					prestação do serviço de consultoria.
				</p>
				<p>
					O uso de dados que identifiquem o profissional diretamente
					(nome completo, imagem) em materiais de divulgação depende
					de autorização específica adicional. O profissional pode
					revogar esta autorização a qualquer momento pelo e-mail
					contato@treino.io.
				</p>

				<h2>6. Proteção de dados</h2>
				<p>
					Implementamos medidas técnicas e organizacionais
					apropriadas para proteger suas informações pessoais contra
					acesso não autorizado, alteração, divulgação ou destruição.
					Essas medidas incluem:
				</p>
				<ul>
					<li>Criptografia de dados sensíveis</li>
					<li>Firewalls e sistemas de segurança</li>
					<li>Acesso restrito às informações pessoais</li>
					<li>Avaliações regulares de segurança</li>
				</ul>
				<p>
					Embora nos esforcemos para proteger suas informações,
					nenhum método de transmissão pela internet ou armazenamento
					eletrônico é 100% seguro. Portanto, não podemos garantir
					segurança absoluta.
				</p>

				<h2>7. Retenção de dados</h2>
				<p>
					Mantemos suas informações pessoais pelo tempo necessário
					para fornecer os serviços solicitados e cumprir com nossas
					obrigações legais. Quando suas informações não forem mais
					necessárias, as excluiremos ou anonimizaremos.
				</p>
				<p>
					Se você solicitar a exclusão da sua conta, removeremos seus
					dados pessoais de nossos sistemas ativos dentro de um prazo
					razoável, exceto quando formos obrigados a mantê-los por
					motivos legais.
				</p>

				<h2>8. Seus direitos de privacidade</h2>
				<p>
					De acordo com a LGPD e demais leis de proteção de dados
					aplicáveis, você tem os seguintes direitos:
				</p>
				<ul>
					<li>
						<strong>Acesso:</strong> direito de acessar os dados
						pessoais que mantemos sobre você
					</li>
					<li>
						<strong>Retificação:</strong> direito de corrigir dados
						imprecisos ou incompletos
					</li>
					<li>
						<strong>Exclusão:</strong> direito de solicitar a
						exclusão de seus dados pessoais
					</li>
					<li>
						<strong>Restrição:</strong> direito de limitar o
						tratamento de seus dados
					</li>
					<li>
						<strong>Portabilidade:</strong> direito de receber seus
						dados em formato estruturado e transferi-los para outro
						provedor
					</li>
					<li>
						<strong>Oposição:</strong> direito de se opor ao
						tratamento de seus dados em certas circunstâncias
					</li>
					<li>
						<strong>Retirada de consentimento:</strong> direito de
						retirar seu consentimento a qualquer momento
					</li>
				</ul>
				<p>
					Para exercer qualquer um desses direitos, entre em contato
					conosco através dos canais indicados na seção "Contato".
				</p>

				<h2>9. Transferências internacionais de dados</h2>
				<p>
					Seus dados pessoais podem ser transferidos e processados em
					países diferentes do seu país de residência, onde nossos
					servidores estão localizados. Implementamos salvaguardas
					apropriadas para garantir que seus dados recebam um nível
					adequado de proteção durante essas transferências.
				</p>

				<h2>10. Menores de idade</h2>
				<p>
					O treino.io não é destinado a menores de 13 anos. Não
					coletamos intencionalmente informações pessoais de crianças
					menores de 13 anos. Se você é pai/mãe ou responsável e
					acredita que seu filho nos forneceu informações pessoais,
					entre em contato conosco para que possamos tomar as medidas
					necessárias para remover essas informações.
				</p>

				<h2>11. Atualizações desta política</h2>
				<p>
					Podemos atualizar esta política de privacidade
					periodicamente para refletir mudanças em nossas práticas ou
					por outros motivos operacionais, legais ou regulatórios.
					Notificaremos você sobre quaisquer alterações materiais
					através da plataforma, do aplicativo ou por outros meios.
				</p>

				<h2>12. Contato</h2>
				<p>
					Se você tiver dúvidas, preocupações ou solicitações
					relacionadas a esta política de privacidade ou ao
					tratamento de seus dados pessoais, entre em contato
					conosco:
				</p>
				<p>
					<strong>E-mail:</strong> contato@treino.io
				</p>
			</div>
		</div>
	);
};

const TermosConteudo = () => {
	return (
		<>
			<style>{`
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
        }
        .termos-page .container {
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            padding: 30px;
            margin-bottom: 30px;
        }
        .termos-page .header {
            text-align: center;
            margin-bottom: 30px;
        }
        .termos-page .logo {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 10px;
        }
        .termos-page .logo-dark {
            color: #1f2937;
        }
        .termos-page .logo-orange {
            color: #f97316;
        }
        .termos-page .footer {
            text-align: center;
            margin-top: 50px;
            color: #6b7280;
            font-size: 0.9rem;
        }
        @media (max-width: 768px) {
            body {
                padding: 15px;
            }
            .termos-page .container {
                padding: 20px;
            }
        }
      `}</style>

			<div className="termos-page">
				<div className="header">
					<div className="logo">
						<span className="logo-dark">trei</span>
						<span className="logo-orange">no</span>
						<span className="logo-dark">.</span>
						<span className="logo-orange">io</span>
					</div>
				</div>

				<div className="container">
					<TermosTexto />
				</div>

				<div className="footer">
					<p>
						Ao usar o treino.io, você reconhece que leu, entendeu e
						concorda em cumprir estes termos de uso e esta política
						de privacidade.
					</p>
					<p>
						&copy; {new Date().getFullYear()} treino.io. Todos os
						direitos reservados.
					</p>
				</div>
			</div>
		</>
	);
};

export default TermosConteudo;
